import React from "react";
import { Link } from "react-router-dom";
import PageHeading from "../components/PageHeading";
import Icon from "../components/Icon";
import { useProgress } from "../utils/progress";

// To use your own pictures, change just these image paths.
// Place files in public/images/periods/ (SVG, JPG, PNG and WebP work).
const periodImage = (name) =>
  `${process.env.PUBLIC_URL}/images/periods/${name}`;
const topics = [
  { key: "haaduud", name: "Хаадын цаг үе", image: periodImage("kings.svg") },
  {
    key: "esh-uzuulegchid",
    name: "Эш үзүүлэгчдийн цаг үе",
    image: periodImage("prophets.svg"),
  },
  {
    key: "zahidal",
    name: "Захидлын цаг үе",
    image: periodImage("letters.svg"),
  },
];

export default function TsagUyPage() {
  const progress = useProgress();
  return (
    <section className="page-shell">
      <PageHeading title="Библийн цаг үеүүдийн дасгал" icon="clock" />
      <div className="list-panel">
        <div className="topic-grid">
          {topics.map((topic, index) => (
            <Link
              to={`/tsag-uy/${topic.key}`}
              className="topic-card"
              key={topic.key}
            >
              <span className="topic-card__number">
                {String(index + 1).padStart(2, "0")}
              </span>
              <span className="topic-card__icon">
                <Icon name="clock" size={25} />
              </span>
              <div className="topic-card__content">
                <h3>{topic.name}</h3>
              </div>
              <div className="topic-card__trailing">
                <span className="topic-card__media" aria-hidden="true">
                  <img
                    src={topic.image}
                    alt=""
                    loading="lazy"
                    decoding="async"
                  />
                  {progress[`tsag-uy-${topic.key}`] && (
                    <span className="topic-card__completed">
                      <Icon name="check" size={18} />
                    </span>
                  )}
                </span>
                <span className="topic-card__arrow">
                  <Icon name="right" size={19} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
